// AGPL-3.0-only — Copyright (C) 2026 Calvin Stefan Iost.
// O scanner especulativo do navegador pode baixar o módulo mesmo após o redirect
// clássico no head. Não exponha main.js como src estático para a rota de contato.
const entryParams = new URLSearchParams(window.location.search);
const contactValue = (entryParams.get('contato') || '').trim().toLowerCase();

/** Teto para o main.js começar mesmo se a tela antecipada travar. */
const MAIN_START_GUARD_MS = 10_000;

/**
 * Primeira visita sem link (só `?lang=` vale). A tela de boas-vindas pode sair antes
 * do grafo do app (main/entry-welcome.ts), que decide de verdade. Na dúvida, não.
 */
function firstVisitWithoutLink(): boolean {
    try {
        if (window.location.hash) return false;
        for (const key of entryParams.keys()) if (key !== 'lang') return false;
        const store = window.localStorage;
        return !store.getItem('ecbyts-first-visit') && store.getItem('ecbyts-welcome-shown') !== 'true';
    } catch {
        return false;
    }
}

if (entryParams.has('contato') && ['', '1', 'true', 'sim'].includes(contactValue)) {
    const destination = new URL('./consultoria.html', window.location.href);
    const language = entryParams.get('lang');
    if (language) destination.searchParams.set('lang', language);
    destination.hash = 'contato';
    window.location.replace(destination.href);
} else if (firstVisitWithoutLink()) {
    // A tela pede ~130 KB; o main.js, ~1,5 MB. Ele espera a tela sair para não
    // dividir a banda com ela (LCP do 1º acesso era ~25 s no Lighthouse mobile).
    let started = false;
    const startMain = () => {
        if (started) return;
        started = true;
        void import('../main.js');
    };
    setTimeout(startMain, MAIN_START_GUARD_MS);
    import('../main/entry-welcome.js')
        .then((m) => m.showEntryWelcome())
        .catch((e) => console.debug('[entry] tela antecipada não saiu:', e?.message || e))
        .finally(startMain);
} else {
    void import('../main.js');
}
